// Learning articles (2026-11-01): the "Articles" tab of the Learning page (src/pages/learning/LearningArticlesTab.tsx).
// Spread into the central LABELS in labels.ts. `t()` takes no variables: `{n}` etc. are substituted by the caller.
export const LEARNING_ARTICLES_LABELS = {
  laTabSettings: { en: 'Settings', he: 'הגדרות' },
  laTabNotes: { en: 'Learning notes', he: 'רשומות למידה' },
  laTabArticles: { en: 'Articles', he: 'מאמרים' },
  laIntro: {
    en: 'When a teammate is consulted or takes over a conversation, the bot writes one article about the case once the conversation closes: what happened, the facts that were established, where the customer was, the solution, what the bot was missing, and the steps to handle it next time. Facts only. An article reaches customers only after it is approved (or auto-published).',
    he: 'כאשר מתייעצים עם נציג או שנציג משתלט על שיחה, הבוט כותב מאמר אחד על המקרה כשהשיחה נסגרת: מה קרה, העובדות שהתבררו, היכן הלקוח היה, הפתרון, מה היה חסר לבוט, והשלבים לטיפול בפעם הבאה. עובדות בלבד. מאמר מגיע ללקוחות רק אחרי שאושר (או פורסם אוטומטית).',
  },
  laSettingsTitle: { en: 'Article settings', he: 'הגדרות מאמרים' },
  laEnabledLabel: { en: 'Write learning articles', he: 'כתיבת מאמרי למידה' },
  laEnabledHint: {
    en: 'Uses AI tokens: one model call per conversation a teammate took part in. Off by default.',
    he: 'צורך טוקנים של בינה מלאכותית: קריאה אחת למודל לכל שיחה שנציג השתתף בה. כבוי כברירת מחדל.',
  },
  laAutoPublishLabel: { en: 'Publish without approval', he: 'פרסום ללא אישור' },
  laAutoPublishHint: {
    en: 'When on, a new article goes into the bot\'s knowledge right away. When off (the default), an admin approves each one here first.',
    he: 'כאשר מופעל, מאמר חדש נכנס מיד לידע של הבוט. כאשר כבוי (ברירת המחדל), מנהל מאשר כל מאמר כאן קודם.',
  },
  laSettingsSaved: { en: 'Settings saved.', he: 'ההגדרות נשמרו.' },
  laSettingsError: { en: 'Could not load or save the article settings.', he: 'לא ניתן היה לטעון או לשמור את הגדרות המאמרים.' },
  laStatusFilter: { en: 'Status', he: 'סטטוס' },
  laStatusAll: { en: 'All', he: 'הכול' },
  laStatus_draft: { en: 'Waiting for approval', he: 'ממתין לאישור' },
  laStatus_published: { en: 'Published', he: 'פורסם' },
  laStatus_dismissed: { en: 'Dismissed', he: 'נדחה' },
  laStatus_skipped: { en: 'Not written', he: 'לא נכתב' },
  laStatus_failed: { en: 'Failed', he: 'נכשל' },
  laStatus_pending: { en: 'Being written', he: 'בכתיבה' },
  laLoading: { en: 'Loading articles…', he: 'טוען מאמרים…' },
  laLoadError: { en: 'Could not load the articles.', he: 'לא ניתן היה לטעון את המאמרים.' },
  laEmpty: { en: 'No articles yet.', he: 'אין עדיין מאמרים.' },
  laTotal: { en: '{n} articles', he: '{n} מאמרים' },
  laPrev: { en: 'Previous', he: 'הקודם' },
  laNext: { en: 'Next', he: 'הבא' },
  laUntitled: { en: '(no title)', he: '(ללא כותרת)' },
  laTokens: { en: '{in} in / {out} out tokens · {model}', he: '{in} נכנסים / {out} יוצאים טוקנים · {model}' },
  laWrittenAt: { en: 'Written', he: 'נכתב' },
  laSession: { en: 'Conversation', he: 'שיחה' },
  laHumanConsulted: { en: 'Teammate consulted', he: 'התייעצות עם נציג' },
  laHumanTookOver: { en: 'Teammate took over', he: 'נציג השתלט' },
  laSimilar: { en: 'Looks like the same case as a published article - consider this an update to it.', he: 'נראה כמו אותו מקרה כמו מאמר שפורסם - כדאי להתייחס לזה כעדכון שלו.' },
  laSkipReason: { en: 'Why no article', he: 'מדוע לא נכתב מאמר' },
  laFieldTitle: { en: 'Title', he: 'כותרת' },
  laFieldContext: { en: 'Context of the conversation', he: 'הקשר השיחה' },
  laFieldFacts: { en: 'Facts established (one per line)', he: 'עובדות שהתבררו (אחת בכל שורה)' },
  laFieldPagePath: { en: 'Page the customer was on', he: 'העמוד שבו היה הלקוח' },
  laFieldPageTitle: { en: 'Page title', he: 'כותרת העמוד' },
  laPageUnknown: { en: 'Unknown (no page reported, e.g. email or WhatsApp)', he: 'לא ידוע (לא דווח עמוד, למשל דוא"ל או וואטסאפ)' },
  laFieldSolution: { en: 'Solution', he: 'פתרון' },
  laFieldMissing: { en: 'What the bot was missing (one per line)', he: 'מה היה חסר לבוט (אחד בכל שורה)' },
  laFieldSteps: { en: 'Steps to handle it next time (one per line)', he: 'שלבים לטיפול בפעם הבאה (אחד בכל שורה)' },
  laFieldKeywords: { en: 'Keywords (one per line)', he: 'מילות מפתח (אחת בכל שורה)' },
  laFieldAltQuestions: { en: 'Other ways a customer may ask (one per line)', he: 'דרכים נוספות שבהן לקוח עשוי לשאול (אחת בכל שורה)' },
  laSave: { en: 'Save changes', he: 'שמירת שינויים' },
  laApprove: { en: 'Approve and publish', he: 'אישור ופרסום' },
  laDismiss: { en: 'Dismiss', he: 'דחייה' },
  laUnpublish: { en: 'Unpublish', he: 'ביטול פרסום' },
  laClose: { en: 'Close', he: 'סגירה' },
  laActionError: { en: 'The action failed. Try again.', he: 'הפעולה נכשלה. נסו שוב.' },
  laConflict: { en: 'The article was changed by someone else. Reload it.', he: 'המאמר שונה על ידי מישהו אחר. טענו אותו מחדש.' },
  laUnavailable: { en: 'The knowledge base could not be reached; nothing changed.', he: 'לא ניתן היה להגיע למאגר הידע; לא בוצע שינוי.' },
  laReadOnlyHint: { en: 'Only a draft can be edited. Unpublish a published article to edit it.', he: 'רק טיוטה ניתנת לעריכה. כדי לערוך מאמר שפורסם, בטלו את פרסומו.' },
};
